module.exports = __webpack_public_path__ + "static/media/ios-hammer.ebb39ea4.svg";